<template>
  <div class="xcard">
    <v-btn small class="mx-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center">LISTADO DE PROYECTOS</h4>
    <p class="ma-0">Responsable DNA - ESAM: EGBERTO BURGOS ERAZO</p>

    <v-row>
      <v-col>
        <v-text-field dense outlined label="Buscar proyecto..."></v-text-field>
      </v-col>
      <v-col>
        <v-btn class="green mr-4" dark>Exportar</v-btn>
        <v-btn class="orange" dark>Imprimir</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="desserts" :items-per-page="5" class="elevation-1"></v-data-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        headers: [
          { text: 'NRO.', value: 'calories' },
          { text: 'ÁREA', value: 'calories' },
          { text: 'TIPO', value: 'calories' },
          { text: 'NOMBRE DE PROYECTO', value: 'calories' },
          { text: 'SEDE ESAM', value: 'calories' },
          { text: 'ASIGNAR SEDE UNSXX', value: 'calories' },
          { text: 'ASIGNAR VERSION', value: 'calories' },
        ],
        desserts: [
          {
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
          },
        ],
      };
    },
    methods: {},
    mounted() {},
  };
</script>
